import { BuildConfig } from "./BuildConfig";

export const initialOrthoExtremitiesBuildConfig: BuildConfig = {
  actionsOrder: ["pick"],
  pick: {
    topLevelSections: {
      textIds: [
        "INCIDENT DESCRIPTION",
        "PATIENT HISTORY",
        "PAST MEDICAL HISTORY",
      ],
    },
  },
} as const;
